import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    list: [],
    listTotal: 0,
    countNum: ''
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListTotal(state, payload) {
      state.listTotal = payload;
    },
    setCountNum(state, payload) {
      state.countNum = payload;
    }
  },
  actions: {
    getList({ commit }, data) {
      api.getList(data).then(({ data }) => {
        commit('setList', data.records || []);
        commit('setListTotal', data.total);
      });
    },

    getCount({ commit }, data) {
      api
        .getPartInCount(data)
        .then(res => {
          commit('setCountNum', res.data);
          if (!res.code) {
            commit('setCountNum', res.data);
          } else {
            commit('setCountNum', '');
          }
        })
        .catch(err => {
          commit('setCountNum', '');
        });
    },
    sendBonus(context, data) {
      return api.sendBonus(data);
    }
  }
};

appStore.registerModule('transferPsi', store);
